module.exports = __webpack_public_path__ + "media/images/flags/sm-7e23c95234800a7c7e1e0a03e8b3702e.svg";